<script>
  import {Event} from '../../plugins/bus';

  export default {
    computed: {
      querystring() {
        if (!this.params) {
          return '';
        }
        return (
          '?' +
          Object.keys(this.params)
            .filter(key => !!this.params[key])
            .map(key => key + '=' + this.params[key])
            .join('&')
        );
      }
    },
    methods: {
      async getUnit(unitId) {
        try {
          this.$wait.start('loading unit');
          const response = await this.$api.get(`units/${unitId}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting the unit');
          return null;
        } finally {
          this.$wait.end('loading unit');
        }
      },
      async getUnits() {
        try {
          this.$wait.start('loading units');
          const response = await this.$api.get(`units${this.querystring}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting units');
          return [];
        } finally {
          this.$wait.end('loading units');
        }
      },
      async getUnitsUsingQuery(query) {
        try {
          let p = {};
          for (let k in query) {
            if (query[k]) {
              p[k] = query[k];
            }
          }

          this.$wait.start('loading units');
          const response = await this.$api.get(`units?${new URLSearchParams(p).toString()}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting units');
          return [];
        } finally {
          this.$wait.end('loading units');
        }
      },
      async getContainers() {
        try {
          this.$wait.start('loading containers');
          const response = await this.$api.get(`containers${this.querystring}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting containers');
          return [];
        } finally {
          this.$wait.end('loading containers');
        }
      },
      async getUnitDefectCategories(unitId) {
        try {
          const unitfilter = (unitId === undefined) ? '' : `?unitId=${unitId}`;
          const response = await this.$api.get(`defect-categories${unitfilter}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting defect categories');
          return [];
        }
      },
      getUnitDefectSubCategories(categoryId) {
        var category = this.categories.find(x => x.id === categoryId);
        if (!category) {
            return [];
        }
        return category.subCategories;
      },
      async updateUnit(unit, configurations) {
        try {
          this.$wait.start('updating unit');
          const response = await this.$api.put(`units/${unit.id}`, {configurationIds: configurations, firstDayOfService: unit.firstDayOfService});
          this.$bus.$emit(Event.UnitUpdated, response.data);
          this.$toast.success(`'${unit.number}' updated`);
          return response;
        } catch (err) {
          this.$toast.error(`Could not update '${unit.number}'`);
        } finally {
          this.$wait.end('updating unit');
        }
      },
      async addMeterReset(unitId, meterResetId, add) {
        try {
          const response = await this.$api.put(`units/${unitId}/meter-resets/${meterResetId}`, add);
          this.$toast.success(`Unit meter reset added`);
          this.$bus.$emit(Event.UnitMeterResetUpdated, response.data);
        } catch (err) {
          this.$toast.error(`Could not add meter reset`);
        }
      },
      async updateMeterReset(unitId, update) {
        try {
          const response = await this.$api.put(`units/${unitId}/meter-resets/${update.id}`, update);
          this.$toast.success(`Unit meter reset updated`);
          this.$bus.$emit(Event.UnitMeterResetUpdated, response.data);
        } catch (err) {
          this.$toast.error(`Could not update meter reset`);
        }
      },
      async deleteMeterReset(unitId, meterResetId) {
        try {
          const response = await this.$api.delete(`units/${unitId}/meter-resets/${meterResetId}`);
          this.$toast.success(`Unit meter reset deleted`);
          this.$bus.$emit(Event.UnitMeterResetDeleted, response.data);
        } catch (err) {
          this.$toast.error(`Could not delete meter reset`);
        }
      },
      async deleteVehicleOffRoad(unitId, vehicleOffRoadId) {
        try {
          const response = await this.$api.delete(`units/${unitId}/vehicle-off-road/${vehicleOffRoadId}`);
          this.$toast.success(`VOR deleted`);
          this.$bus.$emit(Event.VehicleOffRoadDeleted, response.data);
        } catch (err) {
          if (err.response && err.response.data && err.response.data.model) {
            this.$toast.error(err.response.data.model[0]);
          } else {
            this.$toast.error(`Could not delete VOR`);
          }
        }
      }
    }
  };
</script>
